/** @format */
import {styled, Theme} from '@mui/material/styles';
import {Box} from '@mui/material';

export const ChartWrapper = styled(Box)(({theme}) => ({
  width: '100%',
  maxHeight: '417px',
  backgroundColor: theme.palette.semantic_dark?.surface?.surface1,
  padding: '16px',
}));

export const ChartTitle = styled(Box)(({theme}) => ({
  fontWeight: 400,
  fontSize: '24px',
  lineHeight: '28px',
  marginBottom: theme.spacing(4),
  color: theme.palette.semantic_dark?.surface?.onSurface,
}));

export const ChartSubTitle = styled(Box)(({theme}) => ({
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '20px',
  marginBottom: theme.spacing(2),
  color: theme.palette.semantic_dark?.surface?.onSurface,
}));

export const TooltipWrapper = styled(Box)(({theme}) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  padding: '12px',
  border: '1px solid #ccc',
  borderRadius: theme.spacing(2),
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
}));

export const TooltipTitle = styled(Box)(() => ({
  fontWeight: 600,
  marginBottom: '8px',
}));

export const TooltipText = styled(Box)(() => ({
  fontSize: '14px',
  color: '#666',
}));

export const getAxisLabelStyle = (theme: Theme) => ({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '14px',
  fill: theme.palette.semantic_dark?.surface?.onSurface,
});

export const getAxisTickStyle = (theme: Theme) => ({
  fill: theme.palette.semantic_dark?.surface?.onSurface,
  fontSize: '10px',
  fontWeight: 400,
  lineHeight: '12px',
});
